import { render, staticRenderFns } from "./WidgetProductReviewsPhotoThumbnailPc.vue?vue&type=template&id=8d9df6a8"
import script from "./WidgetProductReviewsPhotoThumbnailPc.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsPhotoThumbnailPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports